import { createSlice } from '@reduxjs/toolkit';
import {
  getAllProductAndServicesApi,
  getProductAndServiceDetailsApi,
  getProductServicesByStoreIdApi
} from './productServiceApi';

// ----------------------------------------------------------------------

const initialState = {
  isActive: false,
  selectedProduct: {},
  productAndServicesList: [],
  isListLoading: false,
  selectedProductAndService: {},
  isProductAndServicesLoading: false,
  productAndServicesListOnStoreID: []
};

const slice = createSlice({
  name: 'product',
  initialState,
  reducers: {},
  extraReducers: {
    [getAllProductAndServicesApi.pending]: (state) => {
      state.isListLoading = true;
    },
    [getAllProductAndServicesApi.fulfilled]: (state, action) => {
      state.isListLoading = false;
      state.productAndServicesList = action.payload;
    },
    [getAllProductAndServicesApi.rejected]: (state) => {
      state.isListLoading = false;
    },
    [getProductAndServiceDetailsApi.fulfilled]: (state, action) => {
      state.selectedProductAndService = action.payload;
    },
    [getProductServicesByStoreIdApi.pending]: (state) => {
      state.isProductAndServicesLoading = true;
    },
    [getProductServicesByStoreIdApi.fulfilled]: (state, action) => {
      state.isProductAndServicesLoading = false;
      state.productAndServicesListOnStoreID = action.payload;
    },
    [getProductServicesByStoreIdApi.rejected]: (state) => {
      state.isProductAndServicesLoading = false;
    }
  }
});
export const productAndServiceAction = slice.actions;

export default slice.reducer;
